import { useTenantFeatureFlag } from "@/hooks/useTenantFeatureFlag";

/**
 * 手帳の画面上の呼び名（PRODUCT_DEV-970）。下部ナビのタブ・ロゴの読み上げ・「〜へ戻る」が
 * すべてこれを使う。戻る場所（ホーム）らしさを出すために「手帳」から「マイ手帳」にした。
 */
export const DIARY_HOME_LABEL = "マイ手帳";

/**
 * マイページ配下の画面から「戻る」で帰る先の呼び名（PRODUCT_DEV-782）
 *
 * 同じ画面がテナント設定によって「マイページ」と「手帳」の2つの名前を持つ。戻るボタンに
 * 名前を直書きすると、**手帳を使っているのに「マイページへ戻る」と出る**。
 */
export const useMyPageLabel = (): string =>
  useTenantFeatureFlag("diaryHome") ? DIARY_HOME_LABEL : "マイページ";
